import { AdminRouter, AdminSidebar, AdminStore } from 'stylemix-vue-admin'
import store from './store'
import { messageGroups } from '../plugins/i18n'

const base = 'settings'

AdminStore.registerModule(base, store)

AdminRouter.addRoute({
  name: `${base}`,
  path: `/${base}`,
  component: () => import('./Wrapper.vue'),
  meta: {
    auth: true,
  },
  children: [
    {
      name: `${base}.section`,
      path: `:section`,
      component: () => import('./Form.vue'),
      meta: {
        auth: true,
      },
    },
  ],
})

AdminSidebar.pushItem({
  id: `${base}`,
  order: 90,
  header: $vm => $vm.$t(`general.menu_settings`),
  text: $vm => $vm.$t(`${base}.title`),
  icon: 'icon-cog',
  permission: 'administer',
  get children() {
    const items = []
    AdminStore.state[base].sections
      .filter(section => section.group !== 'email_templates')
      .forEach(section => {
        items.push({
          id: `${base}.${section.key}`,
          route: {
            name: `${base}.section`,
            params: {
              section: section.key,
            },
          },
          order: section.order,
          text: $vm => $vm.$t(`${base}.sections.${section.key}`),
          icon: 'icon-cog',
          permission: 'administer',
        })
      })

    return items
  },
})
AdminSidebar.pushItem({
  id: `${base}`,
  order: 91,
  header: $vm => $vm.$t(`general.menu_settings`),
  text: $vm => $vm.$t('general.email_templates'),
  icon: 'icon-envelope',
  permission: 'administer',
  get children() {
    const items = []
    AdminStore.state[base].sections
      .filter(section => section.group === 'email_templates')
      .forEach(section => {
        items.push({
          id: `${base}.${section.key}`,
          route: {
            name: `${base}.section`,
            params: {
              section: section.key,
            },
          },
          order: section.order,
          text: $vm => $vm.$t(`${base}.sections.${section.key}`),
          icon: 'icon-code',
          permission: 'administer',
        })
      })

    return items
  },
})

messageGroups.push(base)
